import { render, staticRenderFns } from "./UsagebyService.vue?vue&type=template&id=cfa73f60&scoped=true"
import script from "./UsagebyService.vue?vue&type=script&lang=js"
export * from "./UsagebyService.vue?vue&type=script&lang=js"
import style0 from "./UsagebyService.vue?vue&type=style&index=0&id=cfa73f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa73f60",
  null
  
)

export default component.exports